import { render, staticRenderFns } from "./TrendKing.vue?vue&type=template&id=f057fbc2&scoped=true"
import script from "./TrendKing.vue?vue&type=script&lang=js"
export * from "./TrendKing.vue?vue&type=script&lang=js"
import style0 from "./TrendKing.vue?vue&type=style&index=0&id=f057fbc2&prod&scoped=true&lang=css"
import style1 from "./TrendKing.vue?vue&type=style&index=1&id=f057fbc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f057fbc2",
  null
  
)

export default component.exports